import { BookMarked, CalendarDays, History as HistoryIcon, MessageSquare } from 'lucide-react';

import type { AppScreenDefinition } from './types';

export const appScreens: AppScreenDefinition[] = [
  {
    id: 'today',
    label: 'Today',
    icon: CalendarDays,
  },
  {
    id: 'log',
    label: 'Log',
    icon: MessageSquare,
  },
  {
    id: 'history',
    label: 'History',
    icon: HistoryIcon,
  },
  {
    id: 'library',
    label: 'Library',
    icon: BookMarked,
  },
];

export const fieldClassName =
  'h-10 rounded-md border border-input bg-background px-3 text-sm outline-none transition focus:border-primary focus:ring-2 focus:ring-ring/20';
